export default "__VITE_ASSET__36ed2a1f__"